(() => {
  function updateLinks(root = document) {
    root.querySelectorAll('a[href]').forEach(link => {
      try {
        const host = new URL(link.href, location.href).hostname;
        if (host === 'typeform.com' || host.endsWith('.typeform.com')) {
          link.target = '_blank';
          link.rel = (link.rel + ' noopener').trim();
        }
      } catch (_) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => updateLinks());
  else updateLinks();
  document.addEventListener('shopify:section:load', event => updateLinks(event.target));
})();